/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Availability } from './';
import {
    AvailabilityFromJSON,
    AvailabilityFromJSONTyped,
    AvailabilityToJSON,
} from './';
import type { Hybrid } from './';
import {
    HybridFromJSON,
    HybridFromJSONTyped,
    HybridToJSON,
} from './';
import type { OnSite } from './';
import {
    OnSiteFromJSON,
    OnSiteFromJSONTyped,
    OnSiteToJSON,
} from './';
import type { Remote } from './';
import {
    RemoteFromJSON,
    RemoteFromJSONTyped,
    RemoteToJSON,
} from './';
import type { WorkingStatus } from './';
import {
    WorkingStatusFromJSON,
    WorkingStatusFromJSONTyped,
    WorkingStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkConditions
 */
export interface WorkConditions {
    /**
     * 
     * @type {WorkingStatus}
     * @memberof WorkConditions
     */
    type: WorkingStatus;
    /**
     * 
     * @type {Availability}
     * @memberof WorkConditions
     */
    availability: Availability;
}

/**
 * Check if a given object implements the WorkConditions interface.
 */
export function instanceOfWorkConditions(value: object): value is WorkConditions {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('availability' in value) || value['availability'] === undefined) return false;
    return true;
}

export function WorkConditionsFromJSON(json: any): WorkConditions {
    return WorkConditionsFromJSONTyped(json, false);
}

export function WorkConditionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkConditions {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'HYBRID') {
            return HybridFromJSONTyped(json, true);
        }
        if (json['type'] === 'ON_SITE') {
            return OnSiteFromJSONTyped(json, true);
        }
        if (json['type'] === 'REMOTE') {
            return RemoteFromJSONTyped(json, true);
        }
    }
    return {
        
        'type': WorkingStatusFromJSON(json['type']),
        'availability': AvailabilityFromJSON(json['availability']),
    };
}

export function WorkConditionsToJSON(value?: WorkConditions | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.type === 'HYBRID') {
            return HybridToJSON(value as Hybrid);
        }
        if (value.type === 'ON_SITE') {
            return OnSiteToJSON(value as OnSite);
        }
        if (value.type === 'REMOTE') {
            return RemoteToJSON(value as Remote);
        }
    }
    return {
        
        'type': WorkingStatusToJSON(value['type']),
        'availability': AvailabilityToJSON(value['availability']),
    };
}

